import _ from 'lodash';
import React from 'react';
import classnames from 'classnames';
import { useRouter } from 'next/router';
import useSWR from 'swr';
import Modal from 'react-modal';
import { ChevronRightIcon } from '@heroicons/react/20/solid';
import { DateTime, Duration } from 'luxon';
import redirectToLogin from 'utils/redirectToLogin';

import { CrossSvg } from 'components/SorraSvg';
import { useFirebaseAuth } from 'contexts/FirebaseAuth';
import { useUserAuth } from 'contexts/UserAuth';
import { useUserData } from 'contexts/UserData';
import { swrFetcher } from 'utils/api';
import useNavConfig from 'hooks/useNavConfig';

const { useEffect, useState } = React;

const ValidScoresModal = (props) => {
  const router = useRouter();
  const { isOpen, setIsOpen, validScoresData } = props;
  let validScores = validScoresData || [];
  validScores = validScores.map((scoreItem) => {
    const { id, score, created_at } = scoreItem;
    const dateGroup = DateTime.fromISO(created_at)
      .plus(Duration.fromObject({ years: 1 }))
      .toFormat('yyyyMM');
    const dateGroupName = DateTime.fromISO(created_at)
      .plus(Duration.fromObject({ years: 1 }))
      .toFormat('yyyy年MM月');
    return {
      ...scoreItem,
      dateGroup,
      dateGroupName,
    };
  });
  const dateGroups = _.groupBy(validScores, 'dateGroup');
  const dateGroupKeys = _.sortBy(Object.keys(dateGroups), (dateGroup) => {
    return parseInt(dateGroup);
  });
  const [groupCollapsedMap, setGroupCollapsedMap] = useState({});
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => {
        setIsOpen(false);
      }}
      shouldCloseOnOverlayClick={false}
      className="relative h-full max-h-none w-full overflow-hidden rounded-none bg-white p-safe-offset-0 focus:outline-none focus:ring-0 lg:h-[670px] lg:w-[480px] lg:rounded-2xl"
      overlayClassName="z-50 absolute flex items-center justify-center top-0 left-0 right-0 bottom-0 w-full h-full bg-[#111928] bg-opacity-50"
    >
      <div className="relative flex h-full w-full flex-col pt-6 lg:pt-4">
        <div className="relative mb-6 flex h-12 shrink-0 items-center justify-center font-medium">
          <button
            className="absolute left-4 top-0 flex h-12 w-12 items-center justify-center rounded-lg border border-[#E7E7E7]"
            onClick={() => {
              setIsOpen(false);
              // setShowClearHistory(false);
            }}
          >
            <div className="h-7 w-7">
              <CrossSvg />
            </div>
          </button>
          <p>積分到期紀錄</p>
        </div>
        <div className="no-scrollbar min-h-0 grow overflow-y-auto px-9 pb-6">
          {dateGroupKeys.map((dateGroup, idx) => {
            const sample = dateGroups[dateGroup][0];
            const groupName = sample.dateGroupName;
            const isCollapsed = groupCollapsedMap[dateGroup] || false;
            return (
              <div key={dateGroup}>
                <div className="flex items-center justify-between">
                  <p className="text-base font-medium">{groupName}</p>
                  <div
                    className="h-6 w-6 cursor-pointer"
                    onClick={() => {
                      setGroupCollapsedMap({
                        ...groupCollapsedMap,
                        [dateGroup]: !isCollapsed,
                      });
                    }}
                  >
                    {!isCollapsed ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="100%"
                        height="100%"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M6.35134 15.2489C6.57638 15.4739 6.88155 15.6002 7.19974 15.6002C7.51794 15.6002 7.82311 15.4739 8.04814 15.2489L11.9997 11.2973L15.9513 15.2489C16.062 15.3635 16.1945 15.4549 16.3409 15.5178C16.4873 15.5807 16.6447 15.6138 16.8041 15.6152C16.9634 15.6166 17.1214 15.5862 17.2689 15.5259C17.4164 15.4655 17.5503 15.3764 17.663 15.2638C17.7757 15.1511 17.8648 15.0171 17.9251 14.8696C17.9855 14.7222 18.0158 14.5641 18.0144 14.4048C18.0131 14.2455 17.98 14.088 17.9171 13.9416C17.8542 13.7952 17.7628 13.6628 17.6481 13.5521L12.8481 8.75209C12.6231 8.52712 12.3179 8.40074 11.9997 8.40074C11.6815 8.40074 11.3764 8.52712 11.1513 8.75209L6.35134 13.5521C6.12638 13.7771 6 14.0823 6 14.4005C6 14.7187 6.12638 15.0239 6.35134 15.2489Z"
                          fill="#4A4A4A"
                        />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="100%"
                        height="100%"
                        viewBox="0 0 25 24"
                        fill="none"
                      >
                        <path
                          fillRule="evenodd"
                          clipTule="evenodd"
                          d="M6.62869 8.75111C6.85372 8.52615 7.15889 8.39977 7.47709 8.39977C7.79528 8.39977 8.10045 8.52615 8.32549 8.75111L12.2771 12.7027L16.2287 8.75111C16.3394 8.6365 16.4718 8.54508 16.6182 8.48219C16.7646 8.4193 16.9221 8.3862 17.0814 8.38481C17.2407 8.38343 17.3988 8.41379 17.5462 8.47413C17.6937 8.53446 17.8277 8.62357 17.9404 8.73624C18.053 8.84891 18.1421 8.98289 18.2025 9.13037C18.2628 9.27784 18.2932 9.43586 18.2918 9.59519C18.2904 9.75453 18.2573 9.91199 18.1944 10.0584C18.1315 10.2048 18.0401 10.3372 17.9255 10.4479L13.1255 15.2479C12.9005 15.4729 12.5953 15.5993 12.2771 15.5993C11.9589 15.5993 11.6537 15.4729 11.4287 15.2479L6.62869 10.4479C6.40372 10.2229 6.27734 9.91771 6.27734 9.59951C6.27734 9.28131 6.40372 8.97614 6.62869 8.75111Z"
                          fill="#4A4A4A"
                        />
                      </svg>
                    )}
                  </div>
                </div>
                {!isCollapsed && (
                  <div className="mt-3 flex flex-col gap-y-2">
                    {dateGroups[dateGroup].map((scoreItem, idx) => {
                      const { id, score, created_at } = scoreItem;
                      const exp = DateTime.fromISO(created_at)
                        .plus(Duration.fromObject({ years: 1 }))
                        .toFormat('dd/MM/yyyy');
                      return (
                        <div
                          key={id}
                          className="flex items-center text-sm text-[#111928]"
                        >
                          <div className="mr-[2.5px] h-4 w-4">
                            <img
                              src="/images/sorra-coin.png"
                              className="h-full w-full object-contain"
                            />
                          </div>
                          <p>{`$${score}`}</p>
                          <div className="grow" />
                          <p>{exp}</p>
                          <p className="ml-1 text-[#9B9B9B]">將逾期</p>
                        </div>
                      );
                    })}
                  </div>
                )}
                <div className="mb-3 mt-6 h-px bg-[#E7E7E7]"></div>
              </div>
            );
          })}
        </div>
        <div
          style={{
            boxShadow:
              '0px -4px 6px -1px rgba(0, 0, 0, 0.10), 0px 2px 4px -2px rgba(0, 0, 0, 0.05)',
          }}
          className="flex h-[72px] shrink-0 items-center justify-center bg-white px-[68px]"
        >
          <button
            className="flex h-12 w-full items-center justify-center rounded-lg bg-sorra-pink"
            onClick={() => {
              router.push('/rewards');
              setIsOpen(false);
            }}
          >
            <p className="text-base font-medium text-white">前往兌換</p>
          </button>
        </div>
      </div>
    </Modal>
  );
};

const CredentialProvider = ({ providers, className = '' }) => {
  const providerList = [
    { id: 'google.com', name: 'Google', image: '/images/icons/google.png' },
    { id: 'facebook.com', name: 'Facebook', image: '/images/icons/fb.png' },
    { id: 'password', name: 'Email', image: '/images/icons/mail.png' },
    { id: 'apple.com', name: 'Apple', image: '/images/icons/apple.png' },
    // {id:'apple.com',}
    { id: 'phone' },
  ];

  const credential = _.reduce(
    providerList,
    (acc, providerData) => {
      const { id: providerId, name, image } = providerData;
      const provider = _.find(providers, { providerId });
      if (provider) {
        if (providerId === 'phone') {
          if (provider.phoneNumber) {
            acc.phoneNumber = _.trim(provider.phoneNumber, '+');
            acc.phoneNumber = acc.phoneNumber.replace(
              /^(\d{2})\d+(\d{2})$/,
              (_, first, last) => {
                return first + '****' + last;
              }
            );
          }
        } else {
          if (!_.isEmpty(provider.email)) {
            acc.email = provider.email;
          }
          if (!acc.provider) {
            acc.provider = name;
            acc.image = image;
          }
        }
      }
      return acc;
    },
    {}
  );
  const hasEmail = !!credential.email;
  return (
    <div
      className={classnames(
        'flex w-full items-center justify-start gap-x-1 overflow-hidden text-sm lg:justify-center',
        className
      )}
    >
      {credential.image && (
        <div className="h-4 w-4 shrink-0">
          <img src={credential.image} className="object-fit" />
        </div>
      )}
      <p className="truncate text-sorra-black">
        {hasEmail
          ? credential.email
          : credential.provider
            ? `${credential.provider}登入`
            : ''}
      </p>
      {credential.phoneNumber && (
        <p className="shrink-0 text-sorra-gray-500">
          ({credential.phoneNumber})
        </p>
      )}
    </div>
  );
};

const ProfileNav = (props) => {
  const router = useRouter();
  const { user, isSignInStatusReady, getAuthorizationHeader } = useUserAuth();
  const { signOut, currentUser } = useFirebaseAuth();
  const { pathname } = router;
  const [isValidScoresModalOpen, setIsValidScoresModalOpen] = useState(false);

  const onYear = Duration.fromObject({ years: 1 });

  useEffect(() => {
    if (isSignInStatusReady && !user) {
      redirectToLogin(router.pathname);
    }
  });

  const {
    data: validScoresData,
    isLoading: isValidScoresLoading,
    mutate: mutateValidScoresLoading,
  } = useSWR(
    user ? '/api/v3/me/validScores' : null,
    (url) => swrFetcher(url, getAuthorizationHeader),
    { fallbackData: [] }
  );

  const topValidScores = _.take(validScoresData || [], 3);

  const { voucherQuantity } = useUserData();
  const navs = useNavConfig(voucherQuantity);

  return (
    <div className="flex w-full flex-col">
      <div
        className="flex w-full flex-shrink-0 flex-col justify-center gap-y-1 rounded-2xl px-3 pb-4 pt-5 lg:gap-y-4 lg:pt-11"
        style={{
          background: 'linear-gradient(91deg, #FFF4E7 40.8%, #FFEAEA 100.11%)',
        }}
      >
        <div className="flex w-full flex-row items-center gap-x-4 gap-y-3.5 lg:flex-col">
          <div className="h-15 w-15 flex-shrink-0 justify-center overflow-hidden rounded-full border border-white bg-[#D6DDFB] lg:h-24 lg:w-24">
            <img
              src={_.get(user, 'picture') || '/svgs/profile-fallback.svg'}
              className="h-full w-full object-cover"
            />
          </div>
          <div className="flex w-full min-w-0 grow flex-col items-start gap-y-px lg:items-center lg:gap-y-1">
            <p className="w-full truncate text-left text-lg font-bold lg:w-full lg:text-center lg:text-2xl">
              {_.get(user, 'name') || ' '}
            </p>
            {currentUser && currentUser.providerData && (
              <CredentialProvider providers={currentUser.providerData} />
            )}
          </div>
        </div>
        <button
          className="flex items-center justify-start pb-3 pl-2 pt-0.5 text-sm font-medium text-gray-500 lg:justify-center lg:pb-0 lg:pl-0 lg:pt-0 lg:text-base"
          onClick={() => {
            router.push('/profile/setting');
          }}
        >
          <p>設定</p>
          <ChevronRightIcon className="h-5 w-5" />
        </button>
        <div className="flex flex-col gap-y-1.5 rounded-2xl bg-white p-4">
          <div className="flex flex-row gap-x-2">
            <img
              src="/svgs/sorra-points-small.svg"
              className="h-[22px] w-[22px]"
            ></img>
            <p className="text-sm font-medium text-sorra-pink">Sorra Dollars</p>
          </div>
          <div className="flex flex-row justify-between">
            <p className="text-lg font-bold text-[#111928]">
              ${Math.max(_.get(user, 'score') || 0, 0)}
            </p>
            <button
              className="flex items-center justify-center text-sm font-medium text-gray-500"
              onClick={() => {
                router.push('/membership');
              }}
            >
              <p>查看會員制度</p>
              <ChevronRightIcon className="h-5 w-5" />
            </button>
          </div>
          {topValidScores.length > 0 && (
            <div className="mt-5 flex flex-col gap-y-2 rounded-lg bg-[#F5F5F5] p-3">
              {topValidScores.map((scoreItem, idx) => {
                const { id, score, created_at } = scoreItem;
                const exp = DateTime.fromISO(created_at)
                  .plus(onYear)
                  .toFormat('dd/MM/yyyy');
                return (
                  <div
                    key={id}
                    className="flex items-center gap-x-1 text-sm text-[#111928]"
                  >
                    <div className="h-4 w-4">
                      <img
                        src="/images/sorra-coin.png"
                        className="h-full w-full object-contain"
                      />
                    </div>
                    <p>{`$${score}`}</p>
                    <div className="grow" />
                    <p>{exp}</p>
                    <p className="text-[#9B9B9B]">將逾期</p>
                  </div>
                );
              })}
              <button
                className="mt-1 text-sm font-medium text-sorra-pink"
                onClick={() => {
                  setIsValidScoresModalOpen(true);
                }}
              >
                查看所有積分到期紀錄
              </button>
            </div>
          )}
        </div>
      </div>
      <div className="flex flex-col px-5 text-base font-medium text-gray-900">
        {navs.map((nav, idx) => {
          return (
            <div
              key={idx}
              className="flex flex-col gap-y-4 border-b border-[#E5E7EB] py-4"
            >
              {nav.map((item, idx) => {
                const { quantity } = item;
                return (
                  <button
                    key={idx}
                    className={classnames(
                      'flex flex-row items-center gap-x-3 stroke-[#111928] text-[#111928] hover:stroke-sorra-pink hover:text-sorra-pink',
                      {
                        'lg:!stroke-sorra-pink lg:!text-sorra-pink':
                          pathname === item.path,
                      }
                    )}
                    onClick={() => {
                      item.handler && item.handler();
                    }}
                  >
                    {item.icon}
                    <p>{item.name}</p>
                    {!_.isNil(quantity) && quantity > 0 && (
                      <div className="ml-auto flex h-5 w-5 items-center justify-center rounded-full bg-sorra-pink text-xs text-white">
                        {quantity}
                      </div>
                    )}
                  </button>
                );
              })}
            </div>
          );
        })}
      </div>
      <ValidScoresModal
        isOpen={isValidScoresModalOpen}
        setIsOpen={setIsValidScoresModalOpen}
        validScoresData={validScoresData || []}
      />
    </div>
  );
};

export default ProfileNav;
